var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberTypeInviteStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1731_22520)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.8125,
    cy: 6.8125,
    r: 5.5,
    fill: "#E5E9F0",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.11699 8.88301C5.04208 8.808 5 8.70633 5 8.60032C5 8.49431 5.04208 8.39263 5.11699 8.31763L7.63455 5.80007H5.93306C5.82697 5.80007 5.72522 5.75792 5.6502 5.6829C5.57517 5.60788 5.53303 5.50613 5.53303 5.40004C5.53303 5.29394 5.57517 5.19219 5.6502 5.11717C5.72522 5.04215 5.82697 5 5.93306 5H8.59996C8.70606 5 8.80781 5.04215 8.88283 5.11717C8.95785 5.19219 9 5.29394 9 5.40004V8.06694C9 8.17303 8.95785 8.27478 8.88283 8.3498C8.80781 8.42483 8.70606 8.46697 8.59996 8.46697C8.49387 8.46697 8.39212 8.42483 8.3171 8.3498C8.24208 8.27478 8.19993 8.17303 8.19993 8.06694V6.36545L5.68238 8.88301C5.60737 8.95792 5.50569 9 5.39968 9C5.29367 9 5.192 8.95792 5.11699 8.88301Z",
    fill: "#3C4657"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1731_22520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberTypeInviteStatus);
export default __webpack_public_path__ + "static/media/MemberTypeInviteStatus.39790d2af9686d239ba77c7e75df7f81.svg";
export { ForwardRef as ReactComponent };